import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const groups = [{
  title: 'MÓDULO INFANTIL (6 a 13 años)',
  tomos: ['Tomo 1 — El juego antes que la técnica', 'Tomo 2 — Fundamentos técnicos paso a paso', 'Tomo 3 — Cómo planificar cada entrenamiento', 'Tomo 4 — Primeros conceptos tácticos', 'Tomo 5 — El entrenador como educador', 'Tomo 6 — La primera competencia']
}, {
  title: 'MÓDULO JUVENIL / ADULTO',
  tomos: ['Tomo 7 — Sistemas ofensivos modernos', 'Tomo 8 — Defensa: del hombre a la zona', 'Tomo 9 — Preparación física específica', 'Tomo 10 — Análisis de juego y estadísticas', 'Tomo 11 — Liderazgo y gestión del equipo', 'Tomo 12 — Del entrenador amateur al profesional']
}];
export function Modules() {
  return <section className="w-full bg-gray-50 py-12 md:py-16 px-4" data-id="element-59">
      <div className="max-w-4xl mx-auto space-y-8" data-id="element-60">
        {groups.map((group, gIndex) => <motion.div key={gIndex} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: gIndex * 0.1
      }} className="bg-white rounded-xl shadow-md border-2 border-blue-100 overflow-hidden" data-id="element-61">
            <div className="bg-blue-600 px-5 py-4" data-id="element-62">
              <h3 className="text-lg md:text-xl font-bold text-white" data-id="element-63">
                {group.title}
              </h3>
            </div>
            <ul className="divide-y divide-gray-100" data-id="element-64">
              {group.tomos.map((tomo, tIndex) => <li key={tIndex} className="flex items-start gap-3 px-5 py-4 text-gray-800" data-id="element-65">
                  <CheckIcon className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" data-id="element-66" />
                  <span className="font-medium" data-id="element-67">{tomo}</span>
                </li>)}
            </ul>
          </motion.div>)}
      </div>
    </section>;
}